export var RETRIEVE_ROOMS = 'RETRIEVE_ROOMS';
export var RESET_ROOMS_LIST = 'RESET_ROOMS_LIST';
export var REORDER_ROOMS_SUCCESS = 'REORDER_ROOMS_SUCCESS';

export var CREATE_ROOM = 'CREATE_ROOM';
export var CREATE_ROOM_SUCCESS = 'CREATE_ROOM_SUCCESS';
export var CREATE_ROOM_ERROR = 'CREATE_ROOM_ERROR';


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/components/Rooms/roomsActionTypes.js
// module id = 104
// module chunks = 0